import { delay, http, HttpResponse } from 'msw';
import { mockTruckerSearchData } from './mockTruckerSearchData';

const mockSearchTrucker = [
  http.get(`${process.env.BFF_TRUCKER_PROFILE_URL}trucker/search`, async () => {
    await delay(2000);

    return HttpResponse.json(mockTruckerSearchData, {
      status: 200,
    });
  }),
];
export { mockSearchTrucker };
